import React from 'react';
import PreLoginSessionCheck from './PreLoginSessionCheck';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import OurTeam from './OurTeam';
import Cambridge from './CambridgeComponent'
import TWA from './TWA';
import MBA from './MBA';
import Student from './StudentComponent';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import $ from 'jquery';

import store, { cecPageNo, twaPageNo, mbaPageNo, schoolPageNo, collegePageNo } from '../../../redux/store';
import { Provider } from 'react-redux';

// ES6 classNameNameNameName-style


class Teampage extends PreLoginSessionCheck {
  constructor(props) {
    super(props);
    this.state = {
      currentTab: "ourteam",
      currentChosenTabIndex: 0
    }

    this.components = {
      0: OurTeam,
      1: Cambridge,
      2: TWA,
      3: MBA,
      4: Student
    };
    this.teamOrder = ["Our Team", "Cambridge Education Consultants", "Teacher Work Attachments(TWA)", "MBA Internships", "Student Internships"];

    this.settings = {
      dots: false,
      infinite: false,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true,
      swipeToSlide: false,
      swipe: false,
      beforeChange: (current, next) => {
        (() => {
          this.setState({
            currentChosenTabIndex: next
          }, () => {
            this.getProductBoxes()
          })
        })()

      }
    };
  }

  setTab = (key) => {
    let me = this;
    this.setState({ currentTab: key });
  }

  ControlledTabs = () => {
    return (
      <Tabs
        id="teampage-tab"
        activeKey={this.state.currentTab}
        onSelect={(k) => this.setTab(k)}
      >
        <Tab eventKey="ourteam" title="Our Team">
          <OurTeam></OurTeam>
        </Tab>

        <Tab eventKey="cambridge" title="Cambridge Education Consultants">
          <Cambridge></Cambridge>
        </Tab>

        <Tab eventKey="twa" title="Teacher Work Attachments(TWA)">
          <TWA></TWA>
        </Tab>

        <Tab eventKey="mba" title="MBA Internships">
          <MBA></MBA>
        </Tab>

        <Tab eventKey="student" title="Student Internships">
          <Student></Student>
        </Tab>
      </Tabs>
    );
  }
  gradeTabClickFn() {
    //console.warn("grade ",e.target.dataset.index);
    /*  const indVal = this.state.currentChosenTabIndex;
     let allElements = Array.from(document.querySelectorAll('.swiper-active'));
     for (let element of allElements) {
       if ($(element).hasClass('swiper-active')) {
         element.classList.remove('swiper-active')
         element.classList.add('grade')
       }
     }
     if ($("#teamswiper" + indVal).hasClass('grade')) {
       $("#teamswiper" + indVal).removeClass('grade')
       $("#teamswiper" + indVal).addClass("swiper-active");
     } */
  }
  renderClassTab(list, indVal) {
    console.log("currentChosenTabIndex === ", this.state.currentChosenTabIndex)
    console.log("indVal === ", indVal)
    if (this.state.currentChosenTabIndex == indVal) {
      return (
        <div className="swiper-slide" key={indVal} >
          <div >
            <div className="swiper-active" id={"teamswiper" + indVal} data-grade={list} data-index={indVal}>
              {list}
            </div>
          </div>
        </div>
      )
    } else {
      return (
        <div className="swiper-slide" key={indVal} >
          <div>
            <div className="grade" id={"teamswiper" + indVal} data-grade={list} data-index={indVal} >
              {list}
            </div>
          </div>
        </div>
      )
    }
  }
  next() {
    this.slider.slickNext();
  }
  previous() {
    this.slider.slickPrev();
  }
  teamSwiper() {
    console.log("Me in teamSwiper.....")
    var me = this;
    return (
      <div className="row tchrswiper teampageswiper">
        <div className="swiper-container row allMiddle teampageswiper-container">
          <div className="col-sm-12 col-xs-12 col-md-12 col-lg-12 imgGal">
            <div className="col-12 text-center scorecardLessons teamholder">
              <Slider ref={c => (this.slider = c)} {...this.settings}>
                {
                  me.teamOrder.map((list, index) =>
                    me.renderClassTab(list, index)
                  )
                }
              </Slider>

            </div>
          </div>
        </div>
      </div>
    )
  }
  getProductBoxes() {
    const TagName = this.components[this.state.currentChosenTabIndex];
    this.gradeTabClickFn();
    return (
      <div className="tchrprodanim teamTagtab">
        <TagName />
      </div>
    )
  }
  render() {

    var me = this;
    return (
      <Provider store={store}>
        <section id="teampage" className="mtb product-main founder teampage">
          <div className="container">
            <div className="">
              {
                (() => {
                  if (this.isMobile() == true) {
                    return (
                      <div>
                        {me.teamSwiper()}
                        <hr />
                        {me.getProductBoxes()}
                      </div>
                    )
                  } else {
                    return this.ControlledTabs()
                  }
                })()
              }
            </div>
          </div>
        </section>
      </Provider >
    );
  }
}

export default Teampage;


// WEBPACK FOOTER //
// ./src/prelogin/src/components/Teampage.js